export default __webpack_public_path__ + "static/media/ic_car.7d10b2bc.svg";